import React from "react";

import "./Separator.css";

function Separator({light, short, margin}) {
    let className = "separator";
    if (light) {
        className += " lightSeparator";
    }
    if (short) {
        className += " shortSeparator";
    }

    return (
        <div className={className} style={{marginTop: margin}} />
    );
}

export default Separator;